import { TextBlockSliceType } from '../../../../../domains/Prismic/BrandPages/BrandPagesDocument';
import { EvaneosPrismicRichText } from '../../../../../domains/Prismic/EvaneosPrismicRichText';

import style from './TextBlockSlice.module.css';

export type TextBlockSliceProps = TextBlockSliceType;

export function TextBlockSlice({ text }: TextBlockSliceProps) {
    return (
        <div className={style.wrapper}>
            <EvaneosPrismicRichText field={text} />
        </div>
    );
}
